import React from "react";
import { connect } from "react-redux";
import Select from "react-dropdown-select";
import "../Forms/css/register.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const token = localStorage.getItem('authToken');

class EditMerchant extends React.Component {
  constructor(props) {
    super(props);
    this.state = {   
      firstName: '',
      lastName: '',
      phone: '',
   
      identityType: 'Passport',
      identityNumber: '',
      address: '',
      deliverymanImage: '',
      identityImage: '',
      email: '',
      password: '',
      confirmPassword: '',
      showPassword: false,
      showConfirmPassword: false,
      submissionStatus: null,
      id: null,
      deliverymanImageFile: null,
      identityImageFile: null,
    };
  }
  
  async componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      await this.fetchData(id);
    } else {
      console.error("No match or id found in props");
    }
  }

  fetchData = async (id) => {
    console.log("Fetch data called with id:", id);
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/superadmin/getbyidDeliveryboy/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const userData = response?.data;
      console.log("Fetch data response:", userData);
      if (userData) {
        this.setState({
          firstName: userData?.firstName || '',
          lastName: userData.lastName || '',
          identityNumber: userData?.identityNumber || '',
          phone: userData?.phone || '',
          address: userData?.address || '',
          deliverymanImage: userData?.deliverymanImage || '',
          identityImage: userData?.identityImage || '',
          email: userData?.email || '',
        });
      } else {
        console.error("No user data found");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleFileChange = (e) => {
    const { name, files } = e.target;
    this.setState({ [`${name}File`]: files[0] });
  };

  togglePasswordVisibility = (field) => {
    this.setState((prevState) => ({
      [field]: !prevState[field]
    }));
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { id } = this.props.match.params;
    const formData = new FormData();
    
    // Append non-file fields
    Object.keys(this.state).forEach(key => {
      if (key.endsWith('File')) {
        if (this.state[key]) {
          formData.append(key.replace('File', ''), this.state[key]);
        }
      } else {
        if (this.state[key] !== '') {
          formData.append(key, this.state[key]);
        }
      }
    });
  
    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        }
      };
      const response = await axios.put(`https://brand.aasmo.in/api/superadmin/updateDeliveryboy/${id}`, formData, config);
      console.log('Response:', response);
      if (response && response.status === 200) {  // Changed to 200 for successful update
        this.setState({ submissionStatus: 'success' });
        console.log('Form submitted successfully');
        setTimeout(() => {
          this.props.history.push('/listDeliveryboy');
        }, 2000);
      } else {
        console.log('Unexpected response:', response);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          console.error('Bad request error:', data);
        } else if (status === 401) {
          console.error('Unauthorized error, please log in again.');
        } else {
          console.error('Error response:', error.response);
        }
      } else {
        console.error('Network or other error:', error);
      }
    }
  };
  

  render() {
    const { submissionStatus, deliverymanImage, identityImage, deliverymanImageFile, identityImageFile } = this.state;
    return (
      <div className="col-md-12">
        <form onSubmit={this.handleSubmit}>
          <div className="card">
            <div className="header">
              <h2>Edit Merchant</h2>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Store Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="storeName"
                      value={this.state.storeName}
                      onChange={this.handleChange}
                      placeholder="Store Name"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Owner Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="ownerName"
                      value={this.state.ownerName}
                      onChange={this.handleChange}
                      placeholder="Owner Name"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Contact Email</label>
                    <input
                      type="email"
                      className="form-control"
                      name="contactEmail"
                      value={this.state.contactEmail}
                      onChange={this.handleChange}
                      placeholder="Ex: abc@example.com"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Contact Phone</label>
                    <input
                      type="text"
                      className="form-control"
                      name="contactPhone"
                      value={this.state.contactPhone}
                      onChange={this.handleChange}
                      placeholder="Ex: 017********"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Store Address</label>
                    <input
                      type="text"
                      className="form-control"
                      name="storeAddress"
                      value={this.state.storeAddress}
                      onChange={this.handleChange}
                      placeholder="Store Address"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Website URL</label>
                    <input
                      type="url"
                      className="form-control"
                      name="websiteURL"
                      value={this.state.websiteURL}
                      onChange={this.handleChange}
                      placeholder="Website URL"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Store Logo</label>
                    <input
                      type="file"
                      className="form-control"
                      name="storeLogo"
                      onChange={this.handleFileChange}
                    />
                    {this.state.storeLogo && (
                      <img
                        src={URL.createObjectURL(this.state.storeLogo)}
                        alt="Store Logo"
                        className="img-thumbnail mt-2"
                      />
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Store Banner Image</label>
                    <input
                      type="file"
                      className="form-control"
                      name="storeBannerImage"
                      onChange={this.handleFileChange}
                    />
                    {this.state.storeBannerImage && (
                      <img
                        src={URL.createObjectURL(this.state.storeBannerImage)}
                        alt="Store Banner"
                        className="img-thumbnail mt-2"
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-primary">Submit</button>
                {submissionStatus === 'success' && <p className="text-success">Merchant added successfully!</p>}
              </div>
            </div>
          
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter(EditMerchant);
